import barcodeGuide from "@assets/images/barcode_guide.svg";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import { makeStyles } from "@material-ui/core/styles";
import { DialogProps } from "@saleor/types";
import { Html5Qrcode, Html5QrcodeSupportedFormats } from "html5-qrcode";
import React, { Fragment, useEffect, useRef, useState } from "react";
const useStyles = makeStyles(
  {
    barcodeContent: {
      "@media (max-width: 900px)": {
        padding: "0"
      }
    },
    barcodeGuide: {
      "@media (max-width: 768px)": {
        padding: "70px 60px"
      },
      left: "0",
      padding: "45px 60px",
      position: "absolute",
      right: "0",
      zIndex: 1
    },
    barcodeGuideImg: {
      width: "100%"
    },
    cameraDialog: {
      "& .MuiDialog-paperWidthMd": {
        maxWidth: "850px"
      }
    },
    cameraScanner: {
      "& video": {
        color: "#b3b3b3"
      },
      maxHeight: "300px",
      textAlign: "center"
    }
  },
  { name: "BarcodeScanner" }
);
export interface StoreOrderBarcodeDialogProps extends DialogProps {
  handleClose: (parcelID: string) => void;
}

const StoreOrderBarcodeDialog: React.FC<StoreOrderBarcodeDialogProps> = props => {
  const { handleClose, open } = props;
  const classes = useStyles(props);

  const [barcodeScanner, setBarcodeScanner] = useState<Html5Qrcode | null>(
    null
  );
  const scannerRef = useRef<Html5Qrcode | null>(null);

  useEffect(() => {
    const initializeScanner = () => {
      if (
        navigator.mediaDevices &&
        typeof navigator.mediaDevices.getUserMedia === "function"
      ) {
        setTimeout(() => {
          const readerElementId = "reader";

          const readerElement = document.querySelector("#reader");

          if (readerElement) {
            const scanner = new Html5Qrcode(readerElementId);

            const detectorConfig = {
              formatsToSupport: [
                Html5QrcodeSupportedFormats.CODE_128,
                Html5QrcodeSupportedFormats.EAN_13,
                Html5QrcodeSupportedFormats.EAN_8
              ],
              fps: 10,
              videoConstraints: {
                height: 300,
                width: 800
              }
            };

            const cameraConfig = {
              facingMode: "environment"
            };

            const onScanSuccess = (decodedText: string) => {
              setBarcodeScanner(null);
              handleClose(decodedText);
            };

            const onScanError = (error: any) => error;

            scanner
              .start(cameraConfig, detectorConfig, onScanSuccess, onScanError)
              .then(() => {
                setBarcodeScanner(scanner);
                scannerRef.current = scanner;
              })
              .catch(onScanError);
          }
        }, 1000);
      }
    };

    if (open && !barcodeScanner && !scannerRef.current) {
      initializeScanner();
    }

    return () => {
      if (scannerRef.current && scannerRef.current.isScanning) {
        scannerRef.current
          .stop()
          .then(() => {
            if (scannerRef.current) {
              scannerRef.current.clear();
            }
          })
          .catch(error => error);

        setBarcodeScanner(null);
        scannerRef.current = null;
      }
    };
  }, [open, barcodeScanner]);

  return (
    <Dialog
      onClose={() => handleClose(null)}
      open={open}
      maxWidth="md"
      className={classes.cameraDialog}
      fullWidth
    >
      <Fragment>
        <DialogTitle>Scan Parcel ID</DialogTitle>
        <DialogContent className={classes.barcodeContent}>
          <Fragment>
            <div className={classes.barcodeGuide}>
              <img className={classes.barcodeGuideImg} src={barcodeGuide} />
            </div>
            <div id="reader" className={classes.cameraScanner}></div>
          </Fragment>
        </DialogContent>
      </Fragment>
    </Dialog>
  );
};
StoreOrderBarcodeDialog.displayName = "StoreOrderBarcodeDialog";
export default StoreOrderBarcodeDialog;
